var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"u-point-filter",on:{"click":_vm.changeFilter}},[(_vm.active)?_c('img',{attrs:{"draggable":"false","src":_vm.icon(true),"alt":""}}):_c('img',{attrs:{"draggable":"false","src":_vm.icon(false),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }